module.exports = __webpack_public_path__ + "img/ccwl-1.c545ac71.png";